import React, { FC, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { palette } from '../../../../theme';
import { getActiveTrainingLogTabIndex, TRAINING_LOG_NAV_ITEMS } from '../../training-log.constants';
import { useTrainingLogContext } from '../../training-log.context';
import { formatAnnualAnchorDisplayDate } from '../../../../helpers/datetime.helpers';
import { getAthleteDisplayName } from '../../training-log.helpers';
import StartDateModal from '../start-date-modal/start-date-modal.component';
import './training-log-header.component.css';

const CalendarIcon: FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const ChevronIcon: FC = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const TrainingLogHeader: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { annualAnchor, hideAnnualStartDate } = useTrainingLogContext();
  const [modalOpen, setModalOpen] = useState(false);

  const athleteName = getAthleteDisplayName();
  const formattedAnchorDate = annualAnchor ? formatAnnualAnchorDisplayDate(annualAnchor) : '';
  const activeTabIndex = getActiveTrainingLogTabIndex(location.pathname);

  return (
    <>
      <div className="top-header">
        {!hideAnnualStartDate && (
          <div className="top-header-left">
            <h3>{athleteName}</h3>
            <button
              type="button"
              className="start-date-btn"
              onClick={() => setModalOpen(true)}
              disabled={!annualAnchor}
            >
              <CalendarIcon />
              <span>{formattedAnchorDate}</span>
              <ChevronIcon />
            </button>
          </div>
        )}
        <Tabs
          className="top-header-tabs"
          value={activeTabIndex}
          onChange={(_e, newValue) => navigate(TRAINING_LOG_NAV_ITEMS[newValue].route)}
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{
            minHeight: 36,
            height: 36,
            bgcolor: palette.grey[100],
            borderRadius: '10px',
            p: '3px',
            flexShrink: 0,
            '.MuiTabs-flexContainer': { gap: '2px', height: '100%' },
            '.MuiTab-root': {
              minHeight: 0,
              height: '100%',
              fontSize: 13,
              color: palette.text.secondary,
              fontWeight: 500,
              padding: '0 14px',
              textTransform: 'none',
              borderRadius: '8px',
              transition: 'background 0.15s, color 0.15s',
              zIndex: 1,
            },
            '.Mui-selected': {
              color: palette.text.primary,
              fontWeight: 700,
              bgcolor: palette.background.paper,
              boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
            },
          }}
        >
          {TRAINING_LOG_NAV_ITEMS.map((item) => (
            <Tab key={item.id} label={item.label} />
          ))}
        </Tabs>
      </div>
      <StartDateModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default TrainingLogHeader;
